import { render } from "./UploadPostMedia.vue?vue&type=template&id=11d33a51&scoped=true"
import script from "./UploadPostMedia.vue?vue&type=script&lang=js"
export * from "./UploadPostMedia.vue?vue&type=script&lang=js"

import "./UploadPostMedia.vue?vue&type=style&index=0&id=11d33a51&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d33a51"]])

export default __exports__